import { logger } from '@/lib/logger';
import { AllowedKeys } from './types';

export const setItemSessionStorage = (key: AllowedKeys, value: any) => {
  try {
    if (typeof window !== 'undefined') {
      const serializedValue = JSON.stringify(value);

      sessionStorage.setItem(key, serializedValue);
    }
  } catch (error) {
    logger.error(error, 'Error setting a key in the session storage');
  }
};

export const getItemSessionStorage = (key: AllowedKeys) => {
  try {
    if (typeof window !== 'undefined') return sessionStorage.getItem(key);
  } catch (error) {
    logger.error(error, 'Error getting a key from the session storage');
  }
};

export const removeItemSessionStorage = (key: AllowedKeys) => {
  try {
    if (typeof window !== 'undefined') sessionStorage.removeItem(key);
  } catch (error) {
    logger.error(error, 'Error removing a key from the session storage');
  }
};

export const setFreshSessionStorage = (key: AllowedKeys, value: any) => {
  removeItemSessionStorage(key);
  setItemSessionStorage(key, value);
};
